var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { attrs: { id: "dictamen-general", fluid: "" } },
    [
      _c(
        "b-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.guardarDictamen.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("b-form-radio-group", {
                    attrs: {
                      "button-variant": "outline-danger",
                      options: _vm.options,
                      disabled: this.revision.estado === this.revisada,
                    },
                    on: { change: _vm.toggleRadioButton },
                    model: {
                      value: _vm.valueEmerito,
                      callback: function ($$v) {
                        _vm.valueEmerito = $$v
                      },
                      expression: "valueEmerito",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "line-break" }),
          _vm._v(" "),
          _vm.valueEmerito === false
            ? _c(
                "b-container",
                {
                  staticClass: "border text-justify",
                  attrs: { id: "dictamen-solicitud" },
                },
                [
                  _c(
                    "b-row",
                    { staticClass: "mt-4" },
                    [
                      _c("b-col", [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("dictamenEmeritos.aceptado1")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("strong", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("dictamenEmeritos.noAceptado")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "line-break",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("dictamenEmeritos.comentarios")
                            ),
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.valueEmerito === null || _vm.valueEmerito === true
            ? _c(
                "b-container",
                {
                  staticClass: "border text-justify",
                  attrs: { id: "dictamen" },
                },
                [
                  _c(
                    "b-row",
                    { staticClass: "mt-4" },
                    [
                      _c("b-col", [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("dictamenEmeritos.aceptado1")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("span", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.solicitud.SOLICITUD_RIZOMA.solicitante.sexo
                                  .id === _vm.Masculino,
                              expression:
                                "solicitud.SOLICITUD_RIZOMA.solicitante.sexo.id === Masculino",
                            },
                          ],
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("dictamenEmeritos.aceptadoM")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("span", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.solicitud.SOLICITUD_RIZOMA.solicitante.sexo
                                  .id === _vm.Femenino,
                              expression:
                                "solicitud.SOLICITUD_RIZOMA.solicitante.sexo.id === Femenino",
                            },
                          ],
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("dictamenEmeritos.aceptadoF")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "line-break",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("dictamenEmeritos.comentarios")
                            ),
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "line-break" }),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-form-textarea", {
                    attrs: {
                      id: "comentarios",
                      placeholder: "Redacte aquí",
                      rows: "4",
                      disabled: this.revision.estado === this.revisada,
                      state: !_vm.$v.dictamenEmerito.comentarios.$invalid,
                      required: "",
                    },
                    model: {
                      value: _vm.dictamenEmerito.comentarios,
                      callback: function ($$v) {
                        _vm.$set(_vm.dictamenEmerito, "comentarios", $$v)
                      },
                      expression: "dictamenEmerito.comentarios",
                    },
                  }),
                  _vm._v(" "),
                  !_vm.$v.dictamenEmerito.comentarios.required
                    ? _c("small", {
                        staticClass: "text-danger",
                        domProps: {
                          textContent: _vm._s(_vm.$t("caracteres.requerido")),
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$v.dictamenEmerito.comentarios.min
                    ? _c("small", {
                        staticClass: "text-danger",
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("caracteres.min", { min: "140" })
                          ),
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$v.dictamenEmerito.comentarios.max
                    ? _c("small", {
                        staticClass: "text-danger",
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("caracteres.max", { max: "10000" })
                          ),
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "float-right" }, [
                    _vm.$v.dictamenEmerito.comentarios.$model?.length <=
                    _vm.caracteresMinimos
                      ? _c("small", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.$v.dictamenEmerito.comentarios.$model
                                  ?.length <= _vm.caracteresFaltantes,
                              expression:
                                "$v.dictamenEmerito.comentarios.$model?.length <= caracteresFaltantes",
                            },
                          ],
                          staticClass: "text-danger",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("caracteres.faltantes", {
                                minimos:
                                  _vm.$v.dictamenEmerito.comentarios.$model
                                    ?.length - _vm.caracteresMinimos,
                              })
                            ),
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$v.dictamenEmerito.comentarios.$model?.length >=
                    _vm.caracteresMinimos
                      ? _c("small", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.$v.dictamenEmerito.comentarios.$model
                                  ?.length <= _vm.caracteresMaximos,
                              expression:
                                "$v.dictamenEmerito.comentarios.$model?.length <= caracteresMaximos",
                            },
                          ],
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("caracteres.escritos", {
                                inicial:
                                  _vm.$v.dictamenEmerito.comentarios.$model
                                    ?.length + _vm.caracterInicial,
                              })
                            ),
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$v.dictamenEmerito.comentarios.$model?.length >
                    _vm.caracteresMaximos
                      ? _c("small", {
                          staticClass: "text-danger",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("caracteres.sobrepasados")
                            ),
                          },
                        })
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: "12" } }, [
                _c("div", { staticClass: "border-top mt-4 mb-4" }, [
                  _c("div", { staticClass: "mb-5 float-right" }),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: "12" } }, [
                _c(
                  "div",
                  { staticClass: "mb-5 float-right" },
                  [
                    this.revision.estado === this.aceptada &&
                    !_vm.$v.dictamenEmerito.comentarios.$invalid
                      ? _c(
                          "b-button",
                          {
                            attrs: {
                              type: "submit",
                              variant: "primary",
                              size: "md",
                              disabled:
                                (_vm.hasAnyAuthority("ROLE_OPERADOR") &&
                                  _vm.authenticated) ||
                                _vm.valueEmerito === null,
                            },
                          },
                          [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("entity.action.save")
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("font-awesome-icon", {
                              staticClass: "mr-2",
                              attrs: { icon: "save" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }